<template>
  <div 
    class="sm-credit-card-item__inner"
    :class="{'sm-default-card': card.default}">
    <div class="sm-credit-card-item__header">
    <h6 class="sm-credit-card-item__title sm-txt-capitalize">{{ fullBrandName(card.brand) }}
    </h6>
     <a
        href="#"
        v-if="setDefault && !card.default"
        class="sm-small"
        @click.prevent="$emit('default-card', card.id)"
      >Set as default</a>
    </div>
    <p class="sm-credit-card-item__number sm-reg">
      <span>xxxx</span>
      <span>xxxx</span>
      <span>xxxx</span>
      {{ card.last4 }}
    </p>
    <p
      class="sm-reg sm-credit-card-item__exp"
    >{{ card.exp_month | twoSymb }}/{{ card.exp_year | lastTwo }}</p>

    <div class="sm-credit-card-item__footer">
      <p class="sm-credit-card-item__actions">
        <a 
          v-if="canDelete"
          href="#" class="sm-small sm-error" 
          @click.prevent="$emit('delete-card', card.id)"
        >Delete</a>
        <a
          v-if="canEdit" 
          href="#" 
          class="sm-small sm-link" 
          @click.prevent="$emit('edit-card', card.id)"
        >Edit</a>
      </p>

      <p 
        class="sm-credit-card-item__brand" 
        :class="`card-brand card-brand-${iconCardBrand(card.brand)}`"
      ></p>
    </div>
  </div>
</template>

<script>
import parseSlug from '@/assets/js/slug';
import { getPaymentBrandIcon, getPaymentBrandName } from '@/utils/pymnt-card';

export default {
  name: "credit-card-index",
  props: {
    card: {
      type: Object,
      required: true
    },
    setDefault: {
      type: Boolean,
      default: true
    },
    canDelete: {
      type: Boolean,
      default: true
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  filters: {
    lastTwo(year) {
      const str = year.toString();
      return str.slice(str.length - 2);
    },
    twoSymb(val) {
      return val <= 9 ? `0${val}` : val;
    }
  },
  methods: {
    fullBrandName(brand) {
      return getPaymentBrandName(brand);
    },
    iconCardBrand(brand) {
      return getPaymentBrandIcon(brand);
    }
  }
};
</script>
